import { useEffect, useState, useMemo, useCallback, Dispatch, SetStateAction } from 'react';
import { CheckboxItem } from 'src/components/base';
import { TableColumnSettings, TableSettingsDto } from 'src/shared/types';
import { ChangeTableKeys } from '../change-table-config';

const defaultState = [
    {
        title: 'change:evbNr',
        value: ChangeTableKeys.insuranceConfirmationNumber,
        checked: true,
    },
    {
        title: 'change:internalInsuranceNotes',
        value: ChangeTableKeys.internalInsuranceNotes,
        checked: true,
    },
    {
        title: 'change:changeType',
        value: ChangeTableKeys.changeType,
        checked: true,
    },
    {
        title: 'change:licenseNumber',
        value: ChangeTableKeys.licenseNumber,
        checked: true,
    },
    {
        title: 'change:result',
        value: ChangeTableKeys.result,
        checked: true,
    },
    {
        title: 'change:owner',
        value: ChangeTableKeys.owner,
        checked: true,
    },
    {
        title: 'change:agencyNumber',
        value: ChangeTableKeys.agencyNumber,
        checked: true,
    },
    {
        title: 'change:date',
        value: ChangeTableKeys.date,
        checked: true,
    },
    {
        title: 'change:startOfContract',
        value: ChangeTableKeys.startOfContract,
        checked: true,
    },
    {
        title: 'change:postcode',
        value: ChangeTableKeys.postcode,
        checked: true,
    },
    {
        title: 'change:place',
        value: ChangeTableKeys.place,
        checked: true,
    },
    {
        title: 'change:street',
        value: ChangeTableKeys.street,
        checked: true,
    },
    {
        title: 'change:houseNumber',
        value: ChangeTableKeys.houseNumber,
        checked: true,
    },
];

interface UseColumnVisibilityStateReturn {
    visibilitySettingsList: CheckboxItem<TableColumnSettings>[];
    hiddenColumns: string[];
    handleColumnSettingsList: (settings: CheckboxItem[]) => void;
}

interface UseColumnVisibilityStateParams {
    settings: TableSettingsDto | null;
    setSettingsDropdownChanged: Dispatch<SetStateAction<boolean>>;
}

export const useColumnVisibilityState = ({
    settings,
    setSettingsDropdownChanged,
}: UseColumnVisibilityStateParams): UseColumnVisibilityStateReturn => {
    const [visibilitySettingsList, setVisibilitySettingsList] =
        useState<CheckboxItem<TableColumnSettings>[]>(defaultState);

    const handleColumnSettingsList = useCallback((newSettingsList): void => {
        setSettingsDropdownChanged(true);
        setVisibilitySettingsList(newSettingsList);
    }, []);

    useEffect(() => {
        if (settings && Array.isArray(settings.columns)) {
            const newList = visibilitySettingsList.map((settingsItem) => {
                return {
                    ...settingsItem,
                    checked:
                        settings?.columns?.find((item) => item.name === settingsItem.value)
                            ?.isShown || false,
                    data: settings?.columns?.find((item) => item.name === settingsItem.value),
                };
            });
            setVisibilitySettingsList(newList);
            setSettingsDropdownChanged(false);
        }
    }, [settings]);

    const hiddenColumns = useMemo(() => {
        return visibilitySettingsList
            .filter((settingItem) => settingItem.checked === false)
            .map((settingItem) => settingItem.value);
    }, [visibilitySettingsList]);

    return { visibilitySettingsList, hiddenColumns, handleColumnSettingsList };
};
